// Format helpers — DD-MM-YYYY everywhere
export function fmtDate(input: string | number | Date | null | undefined): string {
  if (!input) {return "";}
  const d = typeof input === "string" || typeof input === "number" ? new Date(input) : input;
  if (isNaN(d.getTime())) {
    // Handle "YYYY-MM-DD" strings explicitly
    if (typeof input === "string" && /^\d{4}-\d{2}-\d{2}/.test(input)) {
      const [y, m, day] = input.slice(0, 10).split("-");
      return `${day}-${m}-${y}`;
    }
    return String(input);
  }
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

export function fmtDateTime(input: string | number | Date | null | undefined): string {
  if (!input) {return "";}
  const d = typeof input === "string" || typeof input === "number" ? new Date(input) : input;
  if (isNaN(d.getTime())) {return String(input);}
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${fmtDate(d)} ${hh}:${mi}`;
}

// For "YYYY-MM-DD" date-only strings (booking_date)
export function fmtDateOnly(s: string | null | undefined): string {
  if (!s) {return "";}
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (!m) {return s;}
  return `${m[3]}-${m[2]}-${m[1]}`;
}
